/* 7AYAA — product behaviour.
   Variant selection, cart submission, size-guide enhancement and the mobile
   sticky buy bar. Shopify remains the source of truth for money and stock. */
(function () {
  'use strict';

  function parseVariants(root) {
    var el = root.querySelector('[data-variant-data]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); }
    catch (e) { return []; }
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function Purchase(root) {
    this.root = root;
    this.picker = root.querySelector('[data-variant-picker]');
    this.variants = this.picker ? parseVariants(this.picker) : [];
    this.form = root.querySelector('form[action*="/cart/add"]');
    this.idInput = root.querySelector('[data-variant-id]');
    this.addButton = root.querySelector('[data-add-button]');
    this.addLabel = root.querySelector('[data-add-label]');
    this.stockNote = root.querySelector('[data-stock-note]');
    this.notifySlot = root.querySelector('[data-notify-slot]');
    this.errorBox = root.querySelector('[data-add-error]');
    this.threshold = parseInt(root.dataset.lowStockThreshold, 10) || 0;
    this.bar = document.querySelector('[data-sticky-buy]');
    this.gallery = document.querySelector('[data-gallery]');
    this.inFlight = false;

    this.bind();
    this.observeStickyBar();
  }

  Purchase.prototype.t = function (key) {
    return this.root.dataset[key] || '';
  };

  Purchase.prototype.bind = function () {
    var self = this;

    if (this.picker) {
      this.picker.addEventListener('change', function (ev) {
        if (!ev.target.matches('.s7-option-input')) return;
        self.onSelect();
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        self.addToCart();
      });
    }

    /* A disabled button emits no click. In notify state pointer events fall
       through to the wrapper, so the wrapper owns this interaction. */
    if (this.bar) {
      this.bar.addEventListener('click', function (ev) {
        if (!self.bar.classList.contains('s7-buybar--notify')) return;
        ev.preventDefault();
        self.revealNotify();
      });
    }
  };

  Purchase.prototype.selectedVariant = function () {
    if (!this.picker) return this.variants[0] || null;

    var chosen = [];
    this.picker.querySelectorAll('.s7-option-input:checked').forEach(function (input) {
      chosen[parseInt(input.dataset.optionPosition, 10) - 1] = input.value;
    });

    for (var i = 0; i < this.variants.length; i++) {
      var variant = this.variants[i];
      var match = true;
      for (var j = 0; j < chosen.length; j++) {
        if (variant.options[j] !== chosen[j]) { match = false; break; }
      }
      if (match) return variant;
    }
    return null;
  };

  Purchase.prototype.onSelect = function () {
    var variant = this.selectedVariant();
    this.render(variant);
    this.syncUrl(variant);
    this.showMedia(variant);
  };

  Purchase.prototype.render = function (variant) {
    var available = !!(variant && variant.available);

    if (this.idInput) this.idInput.value = variant ? variant.id : '';

    var currentPrice = this.root.querySelector('[data-price-current]');
    var comparePrice = this.root.querySelector('[data-price-compare]');
    var saving = this.root.querySelector('[data-price-save]');
    var priceWrap = this.root.querySelector('[data-price]');

    if (currentPrice && variant) currentPrice.textContent = variant.price;
    if (priceWrap) priceWrap.classList.toggle('s7-price--sale', !!(variant && variant.compareAtPrice));
    if (comparePrice) {
      comparePrice.textContent = variant && variant.compareAtPrice ? variant.compareAtPrice : '';
      comparePrice.hidden = !(variant && variant.compareAtPrice);
    }
    if (saving) {
      saving.textContent = variant && variant.saving ? variant.saving : '';
      saving.hidden = !(variant && variant.saving);
    }

    if (this.addButton) this.addButton.disabled = !available;
    if (this.addLabel) {
      if (!variant) this.addLabel.textContent = this.t('tUnavailable');
      else if (!available) this.addLabel.textContent = this.t('tSoldout');
      else this.addLabel.textContent = this.t('tAdd') + ' — ' + variant.price;
    }

    if (this.stockNote && variant) {
      var state = 'out';
      var text = this.t('tSoldOutIn').replace('[option]', variant.title);
      if (available) {
        state = 'in';
        text = this.t('tInStock');
        if (this.threshold > 0 && variant.inventoryManagement && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= this.threshold) {
          state = 'low';
          text = this.t('tLowStock').replace('[count]', variant.inventoryQuantity);
        }
      }
      this.stockNote.dataset.state = state;
      this.stockNote.textContent = text;
    }

    if (this.picker) {
      this.picker.querySelectorAll('.s7-option-input:checked').forEach(function (input) {
        var output = this.picker.querySelector('[data-option-selected="' + input.dataset.optionPosition + '"]');
        if (output) output.textContent = input.value;
      }, this);
    }

    if (this.notifySlot) this.notifySlot.hidden = available;

    if (this.bar) {
      var barVariant = this.bar.querySelector('[data-bar-variant]');
      var barPrice = this.bar.querySelector('[data-bar-price]');
      var barCta = this.bar.querySelector('[data-bar-cta]');
      var barLabel = this.bar.querySelector('[data-bar-label]');

      if (barVariant && variant) barVariant.textContent = variant.title;
      if (barPrice && variant) barPrice.textContent = variant.price;
      if (barCta) {
        barCta.disabled = !available;
        barCta.classList.toggle('s7-btn--primary', available);
        barCta.classList.toggle('s7-btn--notify', !available);
        barCta.style.pointerEvents = available ? '' : 'none';
      }
      if (barLabel) {
        barLabel.textContent = available
          ? this.t('tAdd')
          : (this.notifySlot ? 'Notify me' : this.t('tSoldout'));
      }
      this.bar.classList.toggle('s7-buybar--notify', !available && !!this.notifySlot);
    }
  };

  Purchase.prototype.syncUrl = function (variant) {
    if (!variant || !this.picker || !window.history || !history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());
  };

  Purchase.prototype.showMedia = function (variant) {
    if (!variant || !variant.featuredMediaId || !this.gallery) return;
    var cell = this.gallery.querySelector('[data-media-id="' + variant.featuredMediaId + '"]');
    if (!cell) return;
    cell.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
  };

  Purchase.prototype.revealNotify = function () {
    if (!this.notifySlot || this.notifySlot.hidden) return;
    this.notifySlot.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'center' });
    var field = this.notifySlot.querySelector('input, button, a');
    if (field) field.focus({ preventScroll: true });
  };

  Purchase.prototype.addToCart = function () {
    var self = this;
    if (!this.form || !this.addButton || this.addButton.disabled || this.inFlight) return;

    var body = new FormData(this.form);
    body.append('sections', 'cart-drawer,cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    this.inFlight = true;
    var restoreLabel = this.addLabel ? this.addLabel.textContent : null;
    this.addButton.disabled = true;
    this.addButton.setAttribute('aria-busy', 'true');
    if (this.addLabel && this.t('tAdding')) this.addLabel.textContent = this.t('tAdding');
    if (this.errorBox) this.errorBox.hidden = true;

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          self.showError(data.description || data.message);
          return;
        }
        document.dispatchEvent(new CustomEvent('s7:cart:added', {
          detail: { item: data, sections: data.sections }
        }));
        if (window.s7Cart && typeof window.s7Cart.open === 'function') window.s7Cart.open();
        else window.location = window.routes.cart_url;
      })
      .catch(function () {
        self.showError(window.s7Strings && window.s7Strings.cartError);
      })
      .then(function () {
        self.inFlight = false;
        self.addButton.removeAttribute('aria-busy');
        var current = self.selectedVariant();
        self.addButton.disabled = !(current && current.available);
        if (self.addLabel && restoreLabel !== null) self.addLabel.textContent = restoreLabel;
      });
  };

  Purchase.prototype.showError = function (message) {
    if (!this.errorBox) return;
    this.errorBox.textContent = message || 'Something went wrong. Please try again.';
    this.errorBox.hidden = false;
  };

  /* Sticky mobile buy bar.

     The bar stays hidden on initial load, even if the primary CTA begins below
     the viewport. It becomes eligible only after the shopper has actually seen
     the primary CTA once, then shows when that CTA has moved above the viewport.
     Scrolling back to the form hides it again. This is entirely observer-driven:
     no scroll listener, no page-percentage threshold, no per-frame work. */
  Purchase.prototype.observeStickyBar = function () {
    if (!this.bar || !this.addButton) return;

    var bar = this.bar;
    var hasSeenPrimary = false;
    bar.hidden = true;

    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (entry.isIntersecting) {
        hasSeenPrimary = true;
        bar.hidden = true;
        return;
      }

      var passedAbove = entry.boundingClientRect.top < 0;
      bar.hidden = !(hasSeenPrimary && passedAbove);
    }, {
      threshold: 0,
      rootMargin: '0px 0px -40px 0px'
    }).observe(this.addButton);
  };

  /* ------------------------------------------------- SIZE GUIDE DRAWER */
  var sizeGuideBound = false;

  function initSizeGuide() {
    if (sizeGuideBound) return;
    sizeGuideBound = true;

    document.addEventListener('click', function (ev) {
      var trigger = ev.target.closest('[data-size-guide]');
      if (!trigger) return;

      var href = trigger.getAttribute('href');
      if (!href) return;

      /* Use the drawer that belongs to the clicked product module. Homepage
         and PDP therefore share the exact same drawer markup, styling and
         fetched guide instead of competing for the first drawer in the DOM. */
      var owner = trigger.closest('.shopify-section');
      var drawer = owner && owner.querySelector('[data-size-drawer]');
      if (!drawer) drawer = document.querySelector('[data-size-drawer]');

      var body = drawer && drawer.querySelector('[data-size-drawer-body]');
      if (!drawer || !body || !window.s7Drawer) return;

      ev.preventDefault();
      drawer.classList.add('is-open');
      window.s7Drawer.open(drawer, trigger);

      if (drawer.dataset.s7SizeLoaded === 'true') return;

      fetch(href)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var table = doc.querySelector('.s7-size');
          if (!table) throw new Error('no table');
          body.innerHTML = '';
          body.appendChild(table);
          drawer.dataset.s7SizeLoaded = 'true';
        })
        .catch(function () {
          window.s7Drawer.close();
          window.location = href;
        });
    });
  }

  function init() {
    initSizeGuide();
    document.querySelectorAll('[data-purchase]').forEach(function (root) {
      if (root.dataset.s7Bound) return;
      root.dataset.s7Bound = 'true';
      new Purchase(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
